<template>
  <div class="profile-page">
    <div class="header"></div>
    <template v-if="isAccess">
      <edit-profile v-if="!isSubmitted" @submitted="showSuccessMessage" />
      <success-message v-if="isSubmitted">
        <h3>Your profile has been successfully updated</h3>
      </success-message>
    </template>
    <login-required v-if="!isAccess" />
  </div>
</template>

<script>
import editProfile from '@/components/profile/edit-profile'
import SuccessMessage from '@/components/submission/success-message'
import LoginRequired from '@/components/common/login-required'

export default {
  name: 'deals',
  components: {
    editProfile,
    SuccessMessage,
    LoginRequired
  },
  data () {
    return {
      isSubmitted: false
    }
  },
  computed: {
    isAccess () {
      return this.$store.getters['tokens/isAccessToken']
    }
  },
  methods: {
    showSuccessMessage () {
      this.isSubmitted = true
      this.$ga.page({
        page: this.$route.path + '/profile/success-update',
        title: 'Success profile update'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-page {
  position: relative;
  padding-top: 100px;
  .header {
    height: 585px;
    background-color: #001D27;
    width: 100%;
    position: absolute;
    top: 0;
  }
}
</style>
